export default {
  getFilas: state => state.filas,
}
